import React from "react";
import classnames from 'classnames';
import { withLocalize, Translate } from "react-localize-redux";
import PropTypes from 'prop-types';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PdfExport from '../../img/icons/BBicons_Export-PDF';
import BbPopover from './popover';

import './refButtons.scss';

class PdfExportButton extends React.Component {
    static propTypes = {
        onClick: PropTypes.func,
        key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        hideLabel: PropTypes.bool,
        titleKey: PropTypes.string,
        isEnabled: PropTypes.bool,
        disabledKey: PropTypes.string,
        withDelayAfterFirstToggle: PropTypes.bool,
        oldIcon: PropTypes.bool
    };

    static defaultProps = {
        onClick: undefined,
        key: undefined,
        hideLabel: false,
        titleKey: 'Common.Button.ExportPdf',
        isEnabled: true,
        disabledKey: undefined,
        withDelayAfterFirstToggle: false,
        oldIcon: false
    };

    render() {
        return (
            <BbPopover
                content={isNullOrUndefined(this.props.disabledKey) ? undefined : this.props.translate(this.props.disabledKey)}
                placement="top"
                targetId={`pdf-export-button-${this.props.key}`}
                toggleOnEvent={this.props.isEnabled || isNullOrUndefined(this.props.disabledKey) ? "toggleNever" : "toggleOnMouse"}
                withDelayAfterFirstToggle={this.props.withDelayAfterFirstToggle}
            >
                {this.renderContent()}
            </BbPopover>
        );
    }

    renderContent() {
        return (
            <div id={`pdf-export-button-${this.props.key}`}
                className={classnames('ref-button ref-pdfExport', { 'is-disabled': !this.props.isEnabled })} title={this.props.translate(this.props.titleKey)}
                onClick={(!this.props.isEnabled || isNullOrUndefined(this.props.onClick)) ? undefined : () => this.props.onClick()}>
                {this.renderLabel()}
                {this.renderIcon()}
            </div>
        );
    }

    renderLabel = () => {
        if (this.props.hideLabel)
            return null;

        return (
            <span className={classnames('link-functional', { 'is-normal': localStorage.locales_url_format === 'normal', 'hide-on-mobile': !this.props.showOnMobile })}>
                <Translate id={this.props.titleKey} />
            </span>
        );
    }

    renderIcon = () => {
        return this.props.oldIcon ?
            <PdfExport className='search-result-icon svg-standard-fill' /> :
            <FontAwesomeIcon icon="file-pdf" className='search-result-icon svg-standard-fill' />;
    }
}

export default withLocalize(PdfExportButton);